import Fetch from '@/utils/Fetch';

const getComments = async (itemID: any, pageIndex: any, pageSize: any) => {
    return await Fetch.post({
        url: '/Comment/GetComments',
        params: {
          itemID,
          pageIndex: pageIndex ? pageIndex : 0,
          pageSize,
        }
    });    
};

const createComment = async (commentText: any, module: any, itemID: any, storeID: any, isPublic: any) => {
    module = !isNaN(parseInt(module)) ? parseInt(module) : module;
    
    let params = {
        commentText,
        itemID,
        module,
        storeID,
        CustomerView: isPublic
    };

    await Fetch.post({
        url: '/Comment',
        params,
    });
};

const updateComment = async (comment: any) => {
    let commentResult = await Fetch.put({
        url: '/Comment',
        params: comment,
    });

    return commentResult;
};

export default {
    getComments,
    createComment,
    updateComment
};
